/* eslint-disable @typescript-eslint/no-explicit-any */
import { api } from "../api";

export interface AgendamentoForm {
  tipoId: string;
  observacao: string;
  petId: string;
}

export type Pet = {
  id: string;
  tutorId: number;
  nome: string;
  especie: 'CACHORRO' | 'GATO';
  genero: 'MACHO' | 'FEMEA';
  porte: 'PEQUENO' | 'MEDIO' | 'GRANDE';
  observacoes?: string;
  createdAt: string;
  updatedAt: string;
};

export type TipoAgendamento = {
  id: string;
  nome: string;
  descricao: string;
  active: boolean;
  hasDisponibilidade: boolean;
  createdAt: string;
  updatedAt: string;
};

export type Tutor = {
  id: number;
  nome: string;
  email: string;
  telefone?: string;
  cpf: string;
  logradouro: string;
  numero: string;
  bairro: string;
  cidade: string;
  estado: string;
  cep: string;
  notificationToken?: string;
};

export type Campanha = {
  id: string;
  nome: string;
  dataEvento: string;
}

export type Agendamento = {
  campanhaId?: string;
  campanha?: Campanha;
  id: string;
  tutorId: number;
  petId: string;
  data?: string;
  status: 'PENDENTE' | 'AGENDADA' | 'CANCELADA' | 'REALIZADA';
  tipoId: string;
  observacao: string;
  createdAt: string;
  updatedAt: string;
  pet: Pet;
  tipo: TipoAgendamento;
  tutor: Tutor;
  turno: 'MANHA' | 'TARDE' | 'NOITE';
};

export type AgendamentoDTO = {
  tipoId: string;
  petId: string;
  observacao: string;
};

export type AgendamentoHistoricoItem = {
  id: string;
  agendamentoId: string;
  descricao: string;
  byTUTOR: boolean;
  status: 'PENDENTE' | 'AGENDADA' | 'CANCELADA';
  userId: string | null;
  createdAt: string;
  updatedAt: string;
  user: { nome: string } | null;
  agendamento_consulta: Agendamento;
};

export type AgendamentoDiaResponse = {
  agendas: Agendamento[];
  data: {
    hoje: string;
    inicio: string;
    fim: string;
  };
};

export class AgendamentoService {
  async createAgendamento(data: AgendamentoForm): Promise<Agendamento> {
    try {
      const response = await api.post("/agendamentos", data);
      return response.data;
    } catch (error: any) {
      throw {
        message: error.response?.data.error || "Erro ao criar agendamento",
      };
    }
  }

  async getAgendamentoHistorico(id: string): Promise<AgendamentoHistoricoItem[]> {
    try {
      const { data } = await api.get(`/agendamentos/historico/${id}`);
    return data;
    } catch (error: any) {
      
      throw {
        message:
          error.response?.data.error || "Erro ao buscar histórico de agendamento",
      };
    }
  }
  


  async getAgendamentos(): Promise<Agendamento[]> {
    try {
      const response = await api.get("/agendamentos");
      return response.data;
    } catch (error: any) {
      throw {
        message: error.response?.data.error || "Erro ao buscar agendamentos",
      };
    }
  }

  async getAgendamentoDia(): Promise<AgendamentoDiaResponse> {
    try {
      const response = await api.get(`/agendamentos/agenda/dia`);
      return response.data;
    } catch (error: any) {
      console.log(error.response.data);
      throw {
        message: error.response?.data.error || "Erro ao buscar agendamento",
      };
    }
  }

  async cancelarAgendamento(id: string, observacoes: string): Promise<Agendamento> {
    try {
      const response = await api.post(`/agendamentos/${id}/cancelar`, { observacoes });
      return response.data;
    } catch (error: any) {
      console.log(error.response.data);
      throw {
        message: error.response?.data.error || "Erro ao cancelar agendamento",
      };
    }
  }

  async getMotivos(): Promise<any> {
    try {
      const response = await api.get("/agendamentos/motivos");
      return response.data;
    } catch (error: any) {
      throw { message: error.response?.data.error || "Erro ao buscar motivos" };
    }
  }
}
